import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Accordion from 'components/ui/Accordion';
import Checkbox from 'components/ui/inputs/Checkbox';
import { SalaryField, HourlyField } from 'components/shared/CompensationFields';

export const SalaryFieldsContainer = styled.div(
  ({ theme }) => `
  .salary-alignments {
    display: block !important;
  }
  label {
    width: auto;
    .label-text {
      position: relative;
      display: block;
      left: 0;
      right: unset;
      width: auto;
      color: ${theme.mediumGray};
      font-size: 0.875rem;
      text-transform: uppercase;
    }
    input {
      padding-right: 15px;
    }
  }
  .calculated-salary,
  .calculated-hourly {
    margin-left: 0 !important;
    text-transform: capitalize;
  }
`,
);

const PayRate = ({ onChange, filters }) => {
  const hasFilter = !!(
    filters.minimum_salary_cents ||
    filters.minimum_hourly_rate_cents ||
    filters.competitive
  );
  const salaryValue = filters.minimum_salary_cents
    ? filters.minimum_salary_cents / 100
    : '';
  const hourlyValue = filters.minimum_hourly_rate_cents
    ? filters.minimum_hourly_rate_cents / 100
    : '';
  const display = {
    hourly: {
      value: hourlyValue.toString(),
    },
    salary: {
      value: salaryValue.toString(),
    },
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
      onChange(e);
    }
  };

  function handleBlur(e) {
    onChange(e);
  }

  return (
    <Accordion title="Minimum Pay Rate" defaultShow={hasFilter} dense>
      <SalaryFieldsContainer id="salaryFieldsContainer">
        <SalaryField
          inputProps={display.salary}
          white="true"
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
        />
        <HourlyField
          inputProps={display.hourly}
          white="true"
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
        />
      </SalaryFieldsContainer>
      <Checkbox
        labelText="Include jobs labeled competitive"
        onChange={onChange}
        checked={!!filters.competitive}
        name="competitive"
        id="competitive"
        labelTestId="competitive"
        value="on"
      />
    </Accordion>
  );
};

PayRate.propTypes = {
  filters: PropTypes.shape({
    minimum_salary_cents: PropTypes.string,
    minimum_hourly_rate_cents: PropTypes.string,
    competitive: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default PayRate;
